import { render, staticRenderFns } from "./OzelTaksitlendirme.vue?vue&type=template&id=45160bec&scoped=true"
import script from "./OzelTaksitlendirme.vue?vue&type=script&lang=ts"
export * from "./OzelTaksitlendirme.vue?vue&type=script&lang=ts"
import style0 from "./OzelTaksitlendirme.vue?vue&type=style&index=0&id=45160bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45160bec",
  null
  
)

export default component.exports